import React from "react"
import { Wave } from "react-animated-text"
import styles from "./Team.module.css"
import ContentIllustration from "./ContentIllustration"
// import { Link } from "react-router-dom";

const ContentTeam = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])

  const text = `Content Team`
  return (
    <div className={styles.container}>
      {width > 768 && <ContentIllustration />}
      <div className={styles.subContainer}>
        <span className={styles.heading}>
          <Wave text={text} effect="stretch" iterations={1} effectChange={2} />
        </span>
        {width <= 768 && <ContentIllustration />}

        <div className={styles.para}>
          You're going to implement numerous magical changes and mind-provoking
          thoughts with your words and sentences here. The work allotted under
          this vertical is fascinating. Suppose you're a part of this magical
          train. In that case, you're going to prepare excellent content for the
          Club in writing informative articles, preparing innosights materials,
          events descriptions, heart-reaching info to bring awareness of the
          Club's progress among our spectators' uncountable interesting tasks
          coming up. &nbsp;
          <a href="/team/content_team" rel="noreferrer">
            Know More...
          </a>
        </div>
      </div>
    </div>
  )
}

export default ContentTeam
